import React, { useState } from 'react';
import { Divider, Card as SUICard } from 'semantic-ui-react';
import log from 'loglevel';
import delve from 'dlv';
import { withApollo } from 'react-apollo';
import styled from 'styled-components';
import ReactGA from 'react-ga';

import { Box, Flex, Button, Text, Image } from 'src/Components/Base';
import { SPACE, COLOR } from 'src/Components/Theme';
import AppContainer from 'src/Routes/AppContainer';
import { getFacultyInfo } from 'src/GraphQL/query/UniFaculty.query';

import { uploadToCloudStorage } from '../../Firebase/Storage/UserUploadImage';

import AdmittedFaculty from './Components/AdmittedFaculty.view';
import { ChooseDepartmentModal } from './Components/ChooseDepartmentModal';
import { ConfirmAdmissionForm } from './Components/ConfirmAdmissionForm.view';
import BrowseDepartmentModal from './Components/BrowseDepartmentModal';
import MyAdmission from './MyAdmission';
import { fbGroupIds } from './fbGroupIds';

const BannerBox = styled(Box)`
  background: url('images/confirm/starbuck_banner.png') center center no-repeat;
  width: 100%;
  min-height: 118px;
  background-color: ${COLOR.white};
  background-size: contain;
`;

const IntroBox = styled(Box)`
  background: url('images/confirm/tidlaew_guide-2.png') center center no-repeat;
  width: 100%;
  min-height: 135px;
  background-color: ${COLOR.white};
  background-size: contain;
`;

const Card = styled(SUICard)`
  &.ui.card {
    width: 100%;
    min-width: 320px;
    border-radius: 8px;
    > .content {
      padding: 16px;
      @media (min-width: 768px) {
        padding: 32px;
      }
    }
  }
`;
const Wrapper = styled(Box)`
  /* border: 1px solid ${COLOR.greyscale.grey1}; */
  /* border-radius: 4px; */
  max-width: 480px;
  margin: 0 auto;
`;

const mapAdmissionValue = ({ school, isUsedApp, phone, ...restFormValue }) => ({
  ...restFormValue,
  school: school,
  telNo: phone,
  isUsedApp: isUsedApp === 'yes' ? true : false,
});

const cleanObj = (obj = {}) => {
  Object.keys(obj).forEach(key => {
    if (obj[key] === undefined) {
      delete obj[key];
    }
  });
  return obj;
};

const ConfirmLanding = ({
  onCreateAdmissionDetail,
  onDeleteAdmissionDetail,
  admissionDetails,
  myInfo,
  client,
  menus,
}) => {
  const [facultyId, setFacultyId] = useState(null);
  const [universityId, setUniversityId] = useState(null);
  const [factDetails, setFactDetails] = useState(null);
  const [isBrowseModalOpen, setBrowseModalOpen] = useState(false);
  const [formInitialValue, setFormInitialValue] = useState(myInfo.userDetails);

  const handleChooseFacultyClick = () => {
    setBrowseModalOpen(true);

    try {
      ReactGA.event({
        category: 'CONFIRM_ADMISSION',
        action: 'Click Choose Faculty',
      });
    } catch (err) {
      log.error('ga error:', err);
    }
  };

  const handleSelect = async uniIdFacId => {
    log.debug('handleSelect', uniIdFacId);
    const [universityId, facultyId] = uniIdFacId.split(':');
    setFacultyId(facultyId);
    setUniversityId(universityId);
    setBrowseModalOpen(false);

    const factDetails = getFacultyInfo(universityId, facultyId);
    log.debug('handleSelect query factDetails:', factDetails);
    setFactDetails(factDetails);
    try {
      ReactGA.event({
        category: 'CONFIRM_ADMISSION',
        action: 'Click Faculty Card',
      });
    } catch (err) {
      log.error('ga error:', err);
    }
  };

  const handleSubmit = async formValue => {
    const {
      myProfile: { uid },
    } = myInfo;
    const universityId = delve(factDetails, 'university.id');
    const userUploadImagePath = await uploadToCloudStorage(formValue.userUploadImage, uid);
    setFormInitialValue(formValue);

    delete formValue.userUploadImage;

    const output = cleanObj({
      ...mapAdmissionValue(formValue),
      userId: uid,
      // TCAS-YEAR
      year: 2021, // TODO: Should be config
      facultyId: delve(factDetails, 'id'),
      facultyName: delve(factDetails, 'name'),
      facultyTagId: delve(factDetails, 'tagId'),
      universityId,
      universityName: delve(factDetails, 'university.name'),

      userUploadImagePath,
    });
    log.debug('handleSubmit', output);

    try {
      ReactGA.event({
        category: 'CONFIRM_ADMISSION',
        action: 'Submit',
      });
    } catch (err) {
      log.error('ga error:', err);
    }

    if (facultyId !== null && facultyId !== undefined && facultyId !== '') {
      if (onCreateAdmissionDetail) {
        onCreateAdmissionDetail(output);
      }
    } else {
      document.getElementById('selectFaculty').scrollIntoView({ behavior: 'smooth' });
    }
  };

  const renderSharing = () => {
    return <MyAdmission {...admissionDetails} onDeleteAdmissionDetail={onDeleteAdmissionDetail} />;
  };

  const renderNeedsConfirm = () => {
    return (
      <Wrapper>
        {/* <BannerBox mb={[0, null, null, 2]} /> */}
        <IntroBox mb={[0, null, null, 2]} />
        <Card style={{ marginTop: 0 }}>
          <Card.Content>
            <Text.Title>คณะที่น้องสอบติด</Text.Title>
            <Divider />
            <AdmittedFaculty
              id="selectFaculty"
              facultyId={facultyId}
              universityId={universityId}
              onChooseFacultyClick={handleChooseFacultyClick}
            />
            <BrowseDepartmentModal
              open={isBrowseModalOpen}
              onClose={() => setBrowseModalOpen(false)}
              onDepartmentClick={id => handleSelect(id)}
            />
            {facultyId && (
              <Box mt={SPACE.large}>
                <ConfirmAdmissionForm
                  onSubmit={handleSubmit}
                  initialValue={formInitialValue}
                  isSubmitDisabled={facultyId === null || facultyId === undefined}
                />
              </Box>
            )}
          </Card.Content>
        </Card>
      </Wrapper>
    );
  };

  return (
    <AppContainer maxWidth={600} variant="campaign" menus={menus}>
      <Box mb={3}>
        <Image
          src="images/confirm/tidlaew_logo.png"
          alt="TCASter ติดแล้ว..บอกต่อ"
          style={{ margin: '0 auto', maxWidth: 480, width: '100%' }}
        />
      </Box>
      <Box>{admissionDetails ? renderSharing() : renderNeedsConfirm()}</Box>
    </AppContainer>
  );
};

export default withApollo(ConfirmLanding);
